import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "~/app/store";

export type SessionExpirationPhase = "active" | "expired" | "login" | "dismissed";

interface SessionExpirationState {
  phase: SessionExpirationPhase;
}

const initialState: SessionExpirationState = {
  phase: "active",
};

const sessionExpirationSlice = createSlice({
  name: "sessionExpiration",
  initialState,
  reducers: {
    sessionExpired: (state) => {
      if (state.phase === "active") {
        state.phase = "expired";
      }
    },
    loginRequestedAfterSessionExpiration: (state) => {
      if (state.phase === "expired") {
        state.phase = "login";
      }
    },
    sessionExpirationFlowDismissed: (state) => {
      if (state.phase === "login") {
        state.phase = "dismissed";
      }
    },
  },
});

export const { loginRequestedAfterSessionExpiration, sessionExpirationFlowDismissed, sessionExpired } =
  sessionExpirationSlice.actions;

export const selectSessionExpirationPhase = (state: RootState) => state.sessionExpiration.phase;

export default sessionExpirationSlice.reducer;
